import React, { useState, useEffect } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Typography from '../../../../atoms/display/typography'

import useStyles from '../style'

import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons'
import { setExpandedFaq } from '../../../../../redux/faq/actions'
import FaqsContentItem from './FaqsContentItem'

function FaqsCategoryItem({
  category,
  key,
  faqsContent,
  triggerExpanded,
  ...props
}) {
  const classes = useStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const activeConversation = useSelector((state) => state.activeConversation)
  const expandedRecovery = useSelector(
    (state) => state.faq?.expanded?.[activeConversation]
  )
  const keyword = useSelector(
    (state) => state.faq?.keyword?.[activeConversation]
  )

  const [expanded, setExpanded] = useState(!!expandedRecovery?.[category])

  const handleExpanded = (isExpanded) => {
    setExpanded(isExpanded)
    dispatch(setExpandedFaq(activeConversation, category, isExpanded))
  }

  useEffect(() => {
    if (!expanded && !!keyword) setExpanded(true)
  }, [triggerExpanded])

  return (
    <Accordion
      onChange={() => {
        handleExpanded(!expanded)
      }}
      expanded={expanded}
      className={classes.accordion}
      key={key}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon style={{ color: '#009ee2' }} />}
        id="accordion-faqs"
        className={classes.accordionParent}
      >
        <Typography>{category}</Typography>
      </AccordionSummary>

      <AccordionDetails style={{ display: 'block' }}>
        {faqsContent
          .filter((faq) =>
            category === t('faqs.category.notfound')
              ? faq.categories === null
              : faq.categories?.includes(category)
          )
          .map((faq, key2) => (
            <FaqsContentItem faq={faq} key={key2} />
          ))}
      </AccordionDetails>
    </Accordion>
  )
}

export default FaqsCategoryItem
